import React, { useState } from 'react';
import Button from '@amzn/meridian/button';
import RadioButton from '@amzn/meridian/radio-button';
import { NotificationMetadata, Status } from '../../api/Notifications/schema';
import { FormattedMessage, useIntl } from 'react-intl';
import { ContentType } from './NotificationsPopover';
import { TitleAndTag } from './commonShell/TitleAndTag';
import { DismissButton } from './commonShell/DismissButton';
import { processNotifLocaleStrings } from '../../Util/NotificationsHelper';
import Auth from '../../Auth';

interface FeedbackNotificationProps {
  key: string;
  externalId: string;
  title: string;
  message: string;
  timestamp?: string;
  dismissable: boolean;
  notificationMetadata: NotificationMetadata;
  handleDismiss(id: string): void;
  submitEvaluation(id: string, data: string): void;
  contentType: ContentType;
  metadata: {};
  options: { option: string }[];
  status?: Status;
}

export const FeedbackNotification: React.FC<FeedbackNotificationProps> = ({
  key,
  externalId,
  title,
  message,
  timestamp,
  dismissable,
  handleDismiss,
  submitEvaluation,
  contentType,
  metadata,
  notificationMetadata,
  options,
  status,
}: FeedbackNotificationProps): React.ReactElement => {
  const intl = useIntl();
  const [checkedValue, setCheckedValue] = useState('');
  return (
    <>
      <TitleAndTag
        title={title}
        message={message}
        timestamp={timestamp}
        status={status}
      />

      <span style={{ paddingLeft: '30px' }}>
        {options &&
          options.map((option: any) => {
            return (
              <RadioButton
                checked={checkedValue === option.option}
                onChange={setCheckedValue}
                name='radio'
                value={option.option}
              >
                {processNotifLocaleStrings(
                  intl,
                  contentType,
                  option.option,
                  metadata
                )}
              </RadioButton>
            );
          })}
      </span>

      <span style={{ paddingLeft: '30px' }}>
        <DismissButton
          externalId={externalId}
          dismissable={dismissable}
          handleDismiss={handleDismiss}
          notificationMetadata={notificationMetadata}
        />
        <Button
          onClick={() => submitEvaluation(externalId, checkedValue)}
          disabled={!checkedValue || Auth.isImpersonating()}
          type='primary'
          size='medium'
          data-csa-c-type='button'
          data-csa-c-slot-id='click-on-Action-button-slot'
          data-csa-c-content-id='click-on-Action-button'
          data-csa-c-description='Click on Notification Evaluation submit button'
          data-csa-c-tag1='Notifications'
          data-csa-c-notification-category={
            notificationMetadata &&
            `${notificationMetadata.notificationCategory}`
          }
          data-csa-c-notification-type={
            notificationMetadata && `${notificationMetadata.notificationType}`
          }
          data-csa-c-notification-id={`${externalId}`}
        >
          <FormattedMessage
            id='cs_perfportal_notifications_evaluation_submit_button'
            defaultMessage='Submit'
            description='Submit button for notification evaluation'
          />
        </Button>
      </span>

      <span style={{ paddingTop: '10px' }}></span>
    </>
  );
};
